module.exports = __webpack_public_path__ + "static/media/icomoon.d4fcfea7.ttf";